import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom'
import ExpoMetadata from './expo-metadata';
import EntryEditor from '../entry-editor/entry-editor';
import LobbyEditor from '../lobby-editor/lobby-editor';
import HallList from '../hall-list/hall-list';
import HallEditor from '../hall-editor/hall-editor';
import BoothList from '../booth-list/booth-list';
import BoothEditor from '../booth-editor/booth-editor';
import ProductEditor from '../product-editor/product-editor';
import ProductList from '../product-list/product-list';
import './expo-editor.css';
import '../common/react-tabs.css';

/** @class ExpoEditor
  * A component for editing a virtual expo
  */
export default class ExpoEditor extends Component {
  /** @function render
    * Renders the component
    */
  render() {
    return (
      <div className="expo-editor">
        <Switch>
          <Route path={"/expos/:expoID/entry"} render={({match})=>(
            <EntryEditor dataURL={`/expos/${match.params.expoID}/entry`} />
          )}/>
          <Route path="/expos/:expoID/lobby" exact={true} render={({match})=>(
            <LobbyEditor dataURL={`/expos/${match.params.expoID}/lobby`} />
          )}/>
          <Route path="/expos/:expoID/halls" render={({match})=>(
            <Switch>
              <Route path="/expos/:expoID/halls/:hallID" render={({match})=>(
                <HallEditor expoID={match.params.expoID} hallID={match.params.hallID} />
              )}/>
              <Route path="/expos/:expoID/halls" render={({match})=>(
                <HallList dataURL={`/expos/${match.params.expoID}/halls`} />
              )}/>
            </Switch>
          )}/>
          <Route path="/expos/:expoID/booths/:boothID" render={({match})=>(
            <BoothEditor expoID={match.params.expoID} boothID={match.params.boothID} />
          )}/>
          <Route path="/expos/:expoID/booths" render={({match})=>(
            <BoothList expoID={match.params.expoID} />
          )}/>
          <Route path="/expos/:expoID/products/:productID" render={({match})=>(
            <ProductEditor expoID={match.params.expoID} productID={match.params.productID} />
          )}/>
          <Route path="/expos/:expoID/products" render={({match})=>(
            <ProductList expoID={match.params.expoID} />
          )}/>
          <Route path="/expos/:expoID/properties" render={({match})=>(
            <ExpoMetadata
              dataURL={`/expos/${match.params.expoID}/metadata`}
              />
          )}/>
        </Switch>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/expo-editor/expo-editor.js